<template>
  <div class="inputArea">
    <div class="inputTextBox">
        <el-input
            type="textarea"
            placeholder="在这里输入需要合成的文本，生成一个音频文件"
            v-model="data.text"
            maxlength="300"
            show-word-limit
            class="textArea"
            resize="none"
            rows="6"/>
    </div>
    <div class="voiceSelectArea">
        <el-skeleton v-if="voiceSourceLoading" :rows="10" />
        <el-tabs v-else class="tts-tabs" v-model="ttsActiveTab" type="border-card" @tab-click="handleTabClick">
            <el-tab-pane v-for="(item,index) in voiceArray" :key="index" :label="item.label" :name="item.name">
                <VoiceTypeSelect v-if="item.name === ttsActiveTab" :options="options" @handleVoiceSelect="handleVoiceSelect"/>
            </el-tab-pane>
        </el-tabs>
    </div>
    <div class="block">
        <span class="block-title">音量：</span>
        <el-slider class="block-slider" v-model="data.volume" :min="0" :max="10" :step="1"/>
    </div>
    <div class="block">
        <span class="block-title">语速：</span>
        <el-radio-group v-model="data.speech_rate" class="block-radio">
            <el-radio label="0.6">0.6</el-radio>
            <el-radio label="0.8">0.8</el-radio>
            <el-radio label="1.0">1.0</el-radio>
            <el-radio label="1.2">1.2</el-radio>
            <el-radio label="1.5">1.5</el-radio>
        </el-radio-group>
    </div>
    <div class="outputFolder">
        <span class="title">保存位置：  {{ getShoreName(saveFolderName) }}
        </span>
        <el-button class="outputFolderButton" size="mini" @click="addFolder">修改</el-button>
    </div>

    <el-button
        type="primary"
        class="generateButton"
        :loading="btnLoading"
        @click="handleSubmit">
        立即合成
    </el-button>

    <el-dialog
      title="保存位置"
      :append-to-body="true"
      :visible.sync="dialogFolderVisible"
      width="600px"
      :before-close="cancelFolder"
    >
      <div class="dialogTree">
        <folderTree
          ref="MugedaAiFolderTree"
          mediaType="audio"
        />
      </div>
      <div  style="text-align: right; margin: 10px 0 0 0">
        <el-button size="small" class="class-cancel" @click="cancelFolder()">
          取消
        </el-button>
        <el-button size="small" type="primary" @click="confirmFolder()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import VoiceTypeSelect from './VoiceTypeSelect.vue'
import folderTree from '@/layout/components/folderTree.vue';

export default {
  name: 'InputArea',
  components: {
    VoiceTypeSelect,
    folderTree
  },
  data() {
    return {
      data: {
        text: undefined,
        informant_id : undefined,
        volume: 5,
        speech_rate: '1.0',
        folder_id: undefined
      },
      saveFolderName: '默认文件夹',
      dialogFolderVisible: false,
      ttsActiveTab: '',
      btnLoading: false,

      voiceArray: [],
      voiceType: {},
      options: [],
      selectedOption: {},
      voiceSourceLoading: false
    };
  },

  mounted() {
    this.getInputConfig()
  },

  methods: {
    getShoreName(name) {
      if (name.length > 5) {
        return name.substr(0, 5) + '...'
      } else {
        return name
      }
    },
    async getInputConfig() {
      try {
        this.voiceSourceLoading = true;

        const { data } = await axios.get('/index/tts/get_configs');

        if (data.status === 0) {
          const newVoiceArray = Object.keys(data.data?.informant_list || {}).map((item, index) => ({
            index,
            label: item,
            name: item
          }))

          this.voiceArray = newVoiceArray;
          this.voiceType = data.data?.informant_list || {}
          this.ttsActiveTab = newVoiceArray[0]?.name;
          const optionArray = (data.data?.informant_list || {})[newVoiceArray[0]?.name].map((item, index) => ({
            ...item,
            selected: index === 0 ? true : false
          }))
          this.options = optionArray;
          this.data.informant_id = optionArray[0]?.id
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.voiceSourceLoading = false;
      }
    },
    handleTabClick(tab, event) {
      const optionArray = this.voiceType[tab.name].map((item, index) => ({
          ...item,
          selected: index === 0 ? true : false
      }))
      this.options = optionArray;
      this.data.informant_id = optionArray[0]?.id
    },
    handleVoiceSelect(value) {
      this.selectedOption = value;
      this.data.informant_id = value.id;
      this.options = [...this.options].map(item => ({
        ...item,
        selected: false
      }));
      this.options = [...this.options].map(item => ({
        ...item,
        selected: item.id === value.id ? true : false
      }));
    },

    handleSubmit() {
      this.$emit('handleSubmit', this.data, this.selectedOption)
    },

    addFolder() {
      this.dialogFolderVisible = true
      this.$nextTick(()=>{

        this.$refs.MugedaAiFolderTree.getAllFolders()
      })
    },

    cancelFolder() {
      this.dialogFolderVisible = false
    },

    confirmFolder() {
      const node = this.$refs.MugedaAiFolderTree.$refs.tree.getCurrentNode()
      if (!node) {
        this.$message({
          type: 'error',
          message: '请选择文件夹',
        })
        return
      }
      this.saveFolderName = node.label
      this.data.folder_id = node.id
      this.cancelFolder()
    }
  },
};
</script>

<style lang="scss" scoped>
.inputArea {
    width: 56%;
    height: 100%;
    padding: 20px;

    .inputTextBox {
        color: #999999;

        margin-bottom: -10px;
        .textArea {
          margin-bottom: 10px;
          position: relative;

          ::v-deep .el-textarea__inner {
            border: none;
            background: #F5F5F5;
            padding: 16px;
          }

          ::v-deep .el-input__count {
            background: #F5F5F5;
            color: #999;
            font-size: 13px;
            position: absolute;
            bottom: 6px;
            right: 6px;
          }
        }
    }

    .voiceSelectArea {
        margin-top: 10px;
        width: 100%;

        ::v-deep .el-tabs--border-card {
          border: none;
          border-radius: 3px;
          overflow: hidden;

          .el-tabs__content {
            padding: 10px;
          }
        }

        ::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
          border-left-color: #FFFFFF;
          border-right-color: #FFFFFF;
        }

        .tts-tabs {
          .loadingContainer {
              width: 100%;
              height: 300px;
              display: flex;
              justify-content: center;
              align-items: center;
          }
        }
    }

    .block {
        margin-top: 10px;
        display: flex;

        .block-title {
          display: inline-block;
          width: 50px;
          font-size: 14px;
          color: #333333;
          line-height: 38px;
        }
        .block-slider {
          width: calc(100% - 55px);
          display: inline-block;
          vertical-align: middle;
          margin-left: 35px;

          ::v-deep .el-slider__runway {
            background-color: #EEEEEE;
          }
        }

        .block-radio {
            width: calc(100% - 55px);
            padding-top: 12px;
            margin-left: 25px;
        }
    }

    .outputFolder {
        margin-top: 10px;
        width: 70%;
        text-align: center;
        display: flex;

        .title {
          font-size: 14px;
          color: #333333;
        }

        .outputFolderButton {
          margin-top: -5px;
          margin-left: 10px;
        }
    }

    .generateButton {
        margin-top: 20px;
        width: 100%;
    }

}

.h5 {
  .inputArea {
    width: 44%;

    .inputTextBox{
      ::v-deep .el-textarea {
       .el-textarea__inner {
          background: #2A2A2A;
          color: #999999
        }

        .el-input__count {
          background: #2A2A2A;
          color: #999999
        }
      }
    }

    .voiceSelectArea {
      border: 1px solid #444;

      ::v-deep .el-tabs--border-card {
        background: #333333;

        .el-tabs__header {

          .el-tabs__nav-wrap {
            background: #2A2A2A;
          }

          .el-tabs__item.is-active {
            border:none;
            background-color: #333333;
          }
        }
      }
    }

    .block {
      .block-title {
        color: #CCCCCC
      }

      ::v-deep .el-slider{
        .el-slider__runway {
          background-color: #444444;
        }
      }
    }

    .outputFolder {
      .title {
        color: #CCC
      }
    }
  }
}

.rich {
  .inputArea {
    width: 47%;
  }
}
</style>
